module.exports = __webpack_public_path__ + "static/icons/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/favicon.ico
// module id = 1/1L
// module chunks = 0